
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/precon/[precon]",
      function () {
        return require("private-next-pages/precon/[precon]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/precon/[precon]"])
      });
    }
  